const bedroomSizeValues = {
    "1-2 Br": {
        low: 455,
        mid: 570,
        high: 685
    },
    "3 Br": {
        low: 796,
        mid: 995,
        high: 1449
    },
    "4 Br": {
        low: 1449,
        mid: 1995,
        high: 2695
    },
    "5 Br": {
        low: 2375,
        mid: 3205,
        high: 4395
    }
};

const initialBoxCount = {
    "1-2 Br": 40,
    "3 Br": 75,
    "4 Br": 110,
    "5 Br": 150
}

export { bedroomSizeValues, initialBoxCount };